import { CommandRequestType } from "app/services/authentication/connection/commandRequestType";
import { ICommandParameters } from "app/services/authentication/connection/iCommandParameters";
import { ErrorDetails, MagiisAccessPortalDTO } from "app/services/authentication/connection/interfaces/apiInterfaces";
import { IRequestCommand } from "app/services/authentication/connection/iRequestCommand";

export class GetMagiiAccessPortal extends IRequestCommand<
  IGetMagiiAccessPortalResponse,
  ErrorDetails,
  IGetMagiiAccessPortalParameters
> {
  override _commandType: CommandRequestType = CommandRequestType.GET;

  override setParameters(parameters: IGetMagiiAccessPortalParameters) {
    this.urlSections.push('magiisaccess');
    this.urlSections.push(`portal`);
    this.urlSections.push(String(parameters.portal));
    this.paramsSections.push(`type=${parameters.type}`);
    this.composeUrl();
  }
}

export interface IGetMagiiAccessPortalParameters extends ICommandParameters{
  portal: number;
  type?: string;
}

export type IGetMagiiAccessPortalResponse = MagiisAccessPortalDTO[];
